<div
    id="main-container"
    [class.selected]="selected"
    [class.current]="current"
>
  <p>{{marker.name}}</p>
</div>
